import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useEditor } from '@tiptap/react';
import { LinkBubbleMenu, RichTextEditorProvider, RichTextField, RichTextReadOnly, } from 'mui-tiptap';
import React from 'react';
import { createDefaultExtensions } from './defaultExtensions.js';
import { RichTextToolbar } from './RichTextToolbar.js';
export function RichTextbox(props) {
    const { content, onChange, canEdit = false, placeholder = 'No content', contentId } = props;
    if (!canEdit) {
        return _jsx(RichTextboxReadOnly, { content: content, placeholder: placeholder });
    }
    return (_jsx(RichTextboxEditor, { content: content, onChange: onChange, placeholder: placeholder }, contentId));
}
function RichTextboxReadOnly({ content, placeholder, }) {
    if (!content) {
        return (_jsx(Typography, { variant: "body2", color: "text.secondary", sx: { fontStyle: 'italic' }, children: placeholder }));
    }
    const extensions = createDefaultExtensions({ placeholder });
    return _jsx(RichTextReadOnly, { content: content, extensions: extensions });
}
function RichTextboxEditor({ content, onChange, placeholder, }) {
    const extensions = createDefaultExtensions({ placeholder });
    const isExternalUpdate = React.useRef(false);
    const isFirstRender = React.useRef(true);
    const editor = useEditor({
        extensions,
        content,
        onUpdate: ({ editor }) => {
            if (isExternalUpdate.current) {
                isExternalUpdate.current = false;
                return;
            }
            onChange?.(editor.getHTML());
        },
    });
    React.useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (editor && content !== editor.getHTML()) {
            isExternalUpdate.current = true;
            editor.commands.setContent(content);
        }
    }, [editor, content]);
    if (!editor) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(RichTextEditorProvider, { editor: editor, children: [_jsx(RichTextField, { variant: "outlined", controls: _jsx(RichTextToolbar, {}) }), _jsx(LinkBubbleMenu, {})] }));
}
//# sourceMappingURL=RichTextbox.js.map